<template>
  <div class="row">

    <div class="col-12 mb-1">
      <button class="btn btn-primary waves-effect waves-light float-right" type="button" @click="addSection">
        Yangi bo`lim qo`shish
      </button>
    </div>

    <div class="col-12 collapse" id="sectionForm">
      <subject-section-form :section="section"
                            @saved="getSubjectSections(currentSections - 1)"/>
    </div>

    <div class="col-md-12">
      <div class="card">
        <ul class="list-group" id="accordion">
          <li class="list-group-item list-group-item-primary">
            <h5 class="m-0"><b>Mavzu bo'limlari</b></h5>
          </li>
          <li class="list-group-item"
              v-for="(sectionItem, index) in subjectSections"
              :key="sectionItem.id">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                {{ index + 1 }}. {{ sectionItem.name }}
              </div>
              <div>
                <div class="d-flex justify-content-center">
                  <button class="btn btn-icon rounded-circle btn-flat-primary waves-effect waves-light"
                          @click="viewSectionContents(sectionItem, index)">
                    <i style="font-size: 1.5rem" class="feather icon-eye"/>
                  </button>
                  <button class="btn btn-icon rounded-circle btn-flat-info waves-effect waves-light"
                          @click="editSection(sectionItem)">
                    <i style="font-size: 1.5rem" class="feather icon-edit"/>
                  </button>
                  <button class="btn btn-icon rounded-circle btn-flat-danger waves-effect waves-light"
                          @click="deleteSection(sectionItem.id)">
                    <i style="font-size: 1.5rem" class="feather icon-trash-2"/>
                  </button>
                </div>
              </div>
            </div>

            <div class="collapse" data-parent="#accordion"
                 :id="`section-${sectionItem.id}`">
              <div class="d-flex justify-content-end my-1">
                <button type="button" class="btn btn-primary waves-effect waves-light"
                        @click="addTopic">
                  Yangi mavzu qo'shish
                </button>
              </div>
              <div class="row mt-1 border">
                <div class="table-responsive">
                  <table class="table table-bordered table-hover">
                    <thead>
                    <th width="50">#</th>
                    <th><strong>Mavzuning nomlanishi</strong></th>
                    <th width="25"/>
                    </thead>
                    <tbody>
                    <tr v-for="(topicItem, index) in sectionTopics">
                      <td>{{ index + 1 }}</td>
                      <td>{{ topicItem.name }}</td>
                      <td class="d-flex justify-content-center">
                        <button class="btn btn-icon rounded-circle btn-flat-info waves-effect waves-light"
                                title="Tahrirlash"
                                @click="editTopic(topicItem)">
                          <i style="font-size: 1.5rem" class="feather icon-edit"/>
                        </button>
                        <button class="btn btn-icon rounded-circle btn-flat-danger waves-effect waves-light"
                                title="O'chirish"
                                @click="deleteTopic(topicItem.id)">
                          <i style="font-size: 1.5rem" class="feather icon-trash-2"/>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="d-flex justify-content-center my-1 w-100" v-if="sectionTopics && sectionTopics.length > 10">
                  <v-pagination v-model="currentTopics"
                                :classes="bootstrapPaginationClasses"
                                :page-count="totalTopics"/>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="d-flex justify-content-center my-1 w-100" v-if="subjectSections && subjectSections.length > 10">
          <v-pagination v-model="currentSections"
                        :classes="bootstrapPaginationClasses"
                        :page-count="totalSections"/>
        </div>
      </div>
    </div>

    <Modal :modal="showModal" @modal-closed="showModal = false" :modal-size="`modal-sm`">
      <topic-form v-if="showModal && deleteApi === ''"
                  :topic="topic"
                  @saved="getSectionTopics(section.id, currentTopics - 1)"/>

      <deleting-modal v-if="showModal && deleteApi !== ''"
                      :delete-api="deleteApi"
                      @deleted="getSubjectSections(currentSections - 1)"/>
    </Modal>
  </div>
</template>

<script>
import SubjectSectionForm from "./SubjectSectionForm";
import vPagination from "vue-plain-pagination";
import Modal from "../../components/Modal";
import DeletingModal from "../../components/DeletingModal";
import TopicForm from "./TopicForm";

export default {
  name: "SubjectSections",
  components: {
    TopicForm,
    DeletingModal,
    Modal,
    SubjectSectionForm,
    vPagination
  },
  data() {
    return {
      subjectSections: '',
      section: {},
      sectionsLoaded: false,
      totalSections: 1,
      currentSections: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      deleteApi: '',
      showModal: false,
      sectionTopics: [],
      topic: {},
      topicsShowed: [],
      totalTopics: 1,
      currentTopics: 1
    }
  },
  methods: {
    getSubjectSections(skip = 0) {
      this.sectionsLoaded = false;
      this.$api.get(`admin/Reference/GetSubjectSectionList?subjectId=${this.$route.params.id}&skip=${skip}&take=10`)
          .then(res => {
            if (!res.error) {
              this.subjectSections = res.result.data;
              this.totalSections = Math.ceil(res.result.total / 10);
              this.topicsShowed = new Array(res.result.data.length).fill(false);
            }
          })
          .catch(err => {

          })
          .finally(() => {
            this.sectionsLoaded = true;
          })
    },
    addSection() {
      this.section = this.createSectionObject();
      $('#sectionForm').collapse('show');
    },
    editSection(section) {
      this.section = this.createSectionObject(section);
      $('#sectionForm').collapse('show');
    },
    deleteSection(sectionId) {
      this.showModal = true;
      this.deleteApi = `admin/Reference/DeleteSubjectSection/${sectionId}`;
    },
    createSectionObject(section = null) {
      if (section)
        return {
          id: section.id,
          name: section.name,
          subjectId: section.subjectId,
          sectionId: section.sectionId,
        };
      else
        return {
          id: 0,
          name: null,
          subjectId: this.$route.params.id,
          sectionId: null,
        };
    },
    viewSectionContents(section, sectionIndex) {
      $(`#section-${section.id}`).collapse('toggle');

      this.topicsShowed[sectionIndex] = !this.topicsShowed[sectionIndex];
      if (this.topicsShowed[sectionIndex]) {
        this.section = section;
        this.getSectionTopics(section.id);

        for (let index = 0; index < this.topicsShowed.length; index++) {
          if (index === sectionIndex)
            continue;
          this.topicsShowed[index] = false;
        }
      }
    },
    getSectionTopics(sectionId, skipView = 0) {
      this.$api.get(`admin/Reference/GetSubjectTopicList?sectionId=${sectionId}&skip=${skipView}&take=10`)
          .then(res => {
            if (!res.error) {
              this.sectionTopics = res.result.data;
              this.totalTopics = Math.ceil(res.result.total / 10);
            }
          })
    },
    deleteTopic(topicId) {
      this.$api.delete(`Admin/Reference/DeleteSubjectTopic/${topicId}`)
          .then(res => {
            if (!res.error) {
              this.getSectionTopics(this.section.id, this.currentTopics - 1);
              this.notificationMessage('Удалено', 'success');
            }
          });
    },
    editTopic(topic) {
      this.topic = this.createTopicObject(topic);
      this.showModal = true;
      this.deleteApi = '';
    },

    addTopic() {
      this.topic = this.createTopicObject();
      this.showModal = true;
      this.deleteApi = '';
    },
    createTopicObject(topic = null) {
      if (topic)
        return {
          id: topic.id,
          name: topic.name,
          sectionId: topic.sectionId
        };
      else
        return {
          id: 0,
          name: '',
          sectionId: this.section.id
        };

    },
  },
  watch: {
    currentSections() {
      this.getSubjectSections(this.currentSections - 1);
    },
    currentTopics() {
      this.getSectionTopics(this.section.id, this.currentTopics - 1);
    },
  },
  created() {
    this.getSubjectSections();
  }
}
</script>

<style scoped>

</style>